



























import { Vue, Component, Prop } from 'vue-property-decorator';
import { store, bus, signout, client } from '../../shared';
import SiteInfo from './SiteInfo.vue';
import Landing from './Landing.vue';
import { UserInfo } from '../../shared/user';
@Component({
    components: {
        SiteInfo,
        Landing,
    },
})
export class Home extends Vue {
    study?: any = {};
    data?: any = {};
    @Prop({ default: '' }) name: string;
    signout = signout;
    get userSession() {
        return store.userSession;
    }
    get hasStudy() {
        return this.study !== undefined;
    }
    get hasData() {
        return this.data !== undefined;
    }
    get welcomeText() {
        let result = '';
        if (this.userInfo && this.userInfo.userInfo) {
            result = `Welcome ${this.userInfo.userInfo.userName}! `;
        }
        return result;
    }
    get userInfo() {
        return store.userInfo;
    }
    async created() {
        if (this.userSession != null && store.userSession != null) {
            // retrieving userInfo...
            const savedSession = JSON.parse(
                localStorage.getItem(store.userSession.userName) || '{}',
            );
            if (!savedSession.rowId) {
                const d = await client.get(
                    new UserInfo({
                        userName: this.userSession.userName,
                        rowId: savedSession.rowId,
                    }),
                );
                bus.$set(store, 'userInfo', d);
            } else {
                const d = await client.get(
                    new UserInfo({ userName: this.userSession.userName }),
                );
                bus.$set(store, 'userInfo', d);
            }
        }
    }
}
export default Home;
